(function(){
    angular
        .module('appback')
        .directive('ngProteinogramaorina', proteinogramaorina);

        proteinogramaorina.$inject = ['ResultadosService','$timeout'];
        function proteinogramaorina(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=proteinogramaorina.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log(scope);

                  if(!scope.item.resultado){
                        scope.item.resultado = { extra : { resultado : { maquina:false, subanalitica : { t:'1'} }}};
                    }else{
                      if(!scope.item.resultado.extra){
                        scope.item.resultado.extra = { resultado : { maquina:false, subanalitica : { t:'1'} }};
                      }
                  }

                  scope.calcularPorcentaje = function(){
                    var resultado = 0;
                    for(var cont = 0;cont<scope.subanaliticas.length;cont++){
                      if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa]) != 'undefined' && !isNaN(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado_porc) && scope.subanaliticas[cont].bloque!=3){
                        resultado += parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado_porc);
                      }
                    }
                    return resultado.toFixed(2);
                  }

                  scope.valorNormalidad = function(subanalitica){
                    var resultado = false;
                    //console.log(scope.item.resultado.extra.resultado);
                    if(typeof(subanalitica.valoresnormalidad.valor)!='undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa]) != 'undefined'){
                      var valorNormalidad = subanalitica.valoresnormalidad.valor.split("-");
                      if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
                        resultado = -1;
                      }else{
                         if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
                            // console.log(parseFloat(subanalitica.resultado.resultado));
                             //console.log(parseFloat(valorNormalidad[1].trim()));
                             resultado = 1;
                         }
                      }
                    }
                    return resultado;
                            
                  }

                  scope.valorNormalidadPor = function(subanalitica){
                    var resultado = false;
                    //console.log(scope.item.resultado.extra.resultado);
                    if(typeof(subanalitica.valoresnormalidad.valor)!='undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa]) != 'undefined'){
                      var valorNormalidad = subanalitica.valoresnormalidad.valor.split("-");
                      if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado_porc)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
                        resultado = -1;
                      }else{
                         if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado_porc)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
                            // console.log(parseFloat(subanalitica.resultado.resultado));
                             //console.log(parseFloat(valorNormalidad[1].trim()));
                             resultado = 1;
                         }
                      }
                    }
                    return resultado;
                            
                  }

                  scope.operacionMatSub = function()
                  {
                    for(var cont2=0;cont2<scope.subanaliticas.length;cont2++){
                      if(scope.subanaliticas[cont2].operacionmat){
                        var operacionMatematica = scope.subanaliticas[cont2].operacionmat;
                        var str = scope.subanaliticas[cont2].operacionmat.match(/{(.*?)}/g);
                        for(var cont=0;cont<str.length;cont++){
                          if(typeof(scope.item.resultado.extra.resultado.subanalitica[str[cont].replace("{","").replace("}","")]) != 'undefined'){
                            var resultado_porc = scope.item.resultado.extra.resultado.subanalitica[str[cont].replace("{","").replace("}","")].resultado_porc;
                            if(!isNaN(resultado_porc)){
                              operacionMatematica = operacionMatematica.replace(str[cont],resultado_porc);
                            }
                          }
                        }
                        if(!operacionMatematica.match(/{(.*?)}/g)){
                          if(!isNaN(eval(operacionMatematica))){
                            if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont2].codigo_alfa]) != 'undefined' && eval(operacionMatematica).toFixed(2)>0){
                              scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont2].codigo_alfa].resultado = eval(operacionMatematica).toFixed(2);
                            }
                          }
                        }
                      }
                    }
                  }

                  scope.cambiarResultado = function(subanalitica){
                    scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado=scope.calcular(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa],subanalitica.p_respecto.codigo_alfa)
                    //console.log( scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa])
                  }

                  scope.calcular = function(resultado,codigo_alfa){
                    if(typeof(scope.item.resultado.extra.resultado.subanalitica[codigo_alfa])=='undefined' || typeof(scope.item.resultado.extra.resultado[codigo_alfa].resultado)=='undefined' || typeof(scope.item.resultado.extra.resultado[codigo_alfa].resultado_porc)=='undefined'){
                      return resultado.resultado;
                    }
                    return  resultado.resultado_porc;
                  }
                  scope.loading = true;
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			              scope.subanaliticas = data.subanaliticas;
                    scope.loading = false;
                    scope.operacionMatSub();
			            });
			        });
		        }
          }
      }
})();